import styled from '@emotion/styled';

export const ExecutiveListContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem;
	}
`;
export const Description = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	text-align: center;
`;
export const Table = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-auto-rows: minmax(40px, auto);
`;

export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #00377b;
	color: white;
	padding: 10px 15px;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: 150%;
`;

export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
	&.point {
		color: #01337d;
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
`;

export const PositionCell = styled(TableCell)`
	color: #00377b;
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
`;
